import React, { useState, useEffect } from "react";
import * as APIS from "../../../service/apis/products.apis";
import AsyncSelect from "react-select";
import { FiUser, FiSearch } from "react-icons/fi";
import { IoMdHeartEmpty } from "react-icons/io"
import { GrCart } from "react-icons/gr"
import { BsCart2 } from "react-icons/bs"
import { useDispatch, useSelector } from "react-redux";
import search_icon from "../../../assets/images/search_icon.png";
import { NavDropdown } from "react-bootstrap";
import { CheckUserDetailToken, Logout } from "service/apis/customer.apis";
import { AddCart, StoreUserData } from "redux/actions/productAction";
import { history } from "redux/store/store";
import menuArrow from '../../../assets/images/Right_arraw.png'
// import { BsThreeDots } from "react-icons/bs";
// import { Dropdown, Button } from "react-bootstrap";
// import { Collapse } from "react-bootstrap";
// import dotImg from "../../../assets/images/dot.png";
// import signIcon from "../../../assets/images/sign_in_icon.jpg";
// import heartIcon from "../../../assets/images/heart_icon.jpg";
// import cartIcon from "../../../assets/images/cart_icon.jpg";
// import logo from "../../../assets/images/logo_with_title.png";
// import x_circle from "../../../assets/images/x-circle.png";
// import plusImg from "../../../assets/images/square_plus.png";
// import minusImg from "../../../assets/images/square_minus.png";
function Nav(props) {
  const [isNav, setIsNav] = useState(false);
  const [open, setOpen] = useState(false);
  const cartCount = useSelector((state) => state?.task?.cartAdded?.length);
  const userData = useSelector((state) => state?.task?.userData);
  const dispatch = useDispatch();
  const [productsList, setProductsList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productValue, setProductValue] = useState("");
  const [customerTokenCheck, setCustomerTokenCheck] = useState()

  const [subMenu, setSubMenu] = useState(false);
  const [subMenu2, setSubMenu2] = useState(false);


  function mobMenu() {
    const menu = document.getElementById("menu");
    menu.classList.toggle("active");
    setIsNav(!isNav)
  }

  function handleMobMenu(e) {
    e.preventDefault();
    setSubMenu(prevID => !prevID);
    // alert('clicked')
  }

  function handleMobMenu2(e) {
    e.preventDefault();
    setSubMenu2(prevID => !prevID);
    // alert('clicked')
  }

  const LogoutUser = async () => {
    try {
      let { data } = await Logout({
        customerAccessToken: userData?.accessToken,
      });
      dispatch(
        StoreUserData({
          emailId: "",
          phoneNumber: "",
          accessToken: "",
          cartData: {},
        })
      );
      dispatch(AddCart([]))
      history.push("/");
    } catch (err) { }
  };

  useEffect(() => {
    temp()
    CheckUser()
  }, [])



  const CheckUser = async () => {
    try {
      let response = await CheckUserDetailToken({ token: userData?.accessToken })
      // setCustomerTokenCheck(response?.data?.customer)
      if (response?.data?.customer == null) {
        dispatch(
          StoreUserData({
            emailId: "",
            phoneNumber: "",
            accessToken: "",
            cartData: {},
          }))
      }
    } catch (err) {

    }
  }

  async function temp() {
    let result = await APIS.GetCategories();
    setCategories(result);
    let prducts = await APIS.ProductSearch({ search: "*" });
    if (prducts.length)
      prducts = prducts.map((x) => (
        {
          label: x.node.title,
          value: x.node.id,
          handle: x.node.handle
        }
      ));


    setProductsList(prducts);
  }

  let getProducts = (data) => {
    try {
      if (typeof data == "object") {
        setProductValue(data);
        history.push(`/product/${data.handle}`);
      }
      APIS.ProductSearch({ search: `*${data}*` }).then((prducts) => {
        if (prducts.length) {
          prducts = prducts.map((x) => ({
            label: x.node.title,
            value: x.node.id,
            handle: `${x.node.handle}`,
          }));
          setProductsList(prducts);
          productsList.unshift({ label: "Shop All", value: "", handle: "/" });
        }
      });
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <div id="topNav" className="w-100">
        <div className="py-1 text-center bg-gradient w-100 d-md-block d-none">
          {/* We’ve restocked the Outlet!{" "} */}
          <p className="m-0">QUALITY GUARANTEED | SHIPPING WORLDWIDE</p>
        </div>
        <div className="py-3 text-center bg-gradient w-100 fs-14 fw-400 d-md-none d-block">
          QUALITY GUARANTEED | SHIPPING WORLDWIDE
        </div>
        <nav className="navbar navbar-expand-lg navbar-light py-sm-4 py-2 px-sm-5">



          <a className="d-sm-none navbar-brand text-left mr-auto pl-2" href="/">
            <img src='https://cdn.shopify.com/s/files/1/0616/7222/6982/files/logo.png' style={{ width: "9rem" }} alt=''></img>
          </a>


          <span onClick={() => history.push("/cart")} className="d-md-none d-block">
            <BsCart2 size={20} color="#00000" />
            <span className="text-black mx-1">
              <span style={{ marginRight: '2px' }}>(</span>
              {cartCount}
              <span style={{ marginLeft: '2px' }}>)</span>
            </span>
          </span>


          <div className="menu" id="menu" onClick={mobMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>


          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
            </ul>
            <a
              className="navbar-brand position-absolute"
              style={{ right: "0", left: "43.5%" }}
              href="/"
            >
              <img src='https://cdn.shopify.com/s/files/1/0616/7222/6982/files/logo.png' style={{ width: "11.1875rem" }} alt=''></img>
            </a>
            <ul className="navbar-nav ml-auto">
              {userData?.accessToken === "" ? (
                <li className="nav-item">
                  <a className="nav-link" href="/auth/login">
                    <FiUser size={20} /> Sign In
                  </a>
                </li>
              ) : (
                <div className="d-flex align-items-center">
                  <NavDropdown
                    // className={styles.userNav}
                    title={
                      <span className="pink fs-15 fw-600">
                        {userData?.firstName} {userData?.lastName}
                      </span>
                    }
                  >
                    {/* <NavDropdown.Item href="/my-account/my-profile">
                      My Profile
                    </NavDropdown.Item> */}

                    <NavDropdown.Item onClick={() => LogoutUser()}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              )}

              {/* <li className="nav-item">
                            <a className="nav-link" href="#"><img src={heartIcon} className="pr-1" /> Favourites</a>
                        </li> */}
              <li className="nav-item">
                <a className="nav-link" href="/orders">
                  <IoMdHeartEmpty size={20} /> My orders
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/cart">
                  <GrCart size={20} /> Cart
                  <span className="mx-1">
                    <span style={{ marginRight: '2px' }}>(</span>
                    {cartCount}
                    <span style={{ marginLeft: '2px' }}>)</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        {
          isNav && (
            <div
              className="w-100 position-fixed row m-0 bg-white h-100 d-sm-none"
              style={{ zIndex: 999, top: 110, transition: '0.3s ease' }}
            >
              <div className="col-11 mx-auto">


                <div className="w-100 p-0 my-3 border-top border-bottom ">
                  <div className="input-group p-0 border-0">
                    <div className="input-group-append">
                      <span
                        className="input-group-text border-0 rounded-0 bg-none"
                        id="basic-addon2"
                      >
                        <img src={search_icon} alt="" style={{ width: '16px', height: '16px' }} />
                      </span>
                    </div>
                    <div className="position-absolute bg-white w-100">
                      <div className={`searchBar px-0 col-12`}>
                        <AsyncSelect
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: '#CDA774',
                              primary: '#b68a68'
                            },
                          })}
                          options={productsList}
                          name={"ProductName"}
                          value={productValue}
                          onChange={(val) => getProducts(val)}
                          onInputChange={(value) => getProducts(value)}
                          placeholder={`Search products.`}
                        />
                        <div className="searchIcon">
                          <FiSearch size={20} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                {/* <span
                  // href="#"
                  className="text-reset text-right d-block pt-3 position-absolute w-100 ml-auto"
                >
                  <img
                    className="mr-3"
                    onClick={() => setIsNav(!isNav)}
                    src={x_circle}
                    alt=""
                  />
                </span> */}



                {/* <a href="#" className="text-reset d-block pt-3">
                My Profile
               </a> */}
                {/* <div className="text-reset pt-5" onClick={() => history.push("/customer_service")}>
                  Customer Service
                </div> */}
                <a href="/orders" className="text-reset d-block mt-4">
                  My Orders
                </a>

                {/* <a href="/auth/login" className="text-reset d-block">
                Sign In
                </a> */}

                <a href="/cart" className="text-reset d-block">
                  My cart
                </a>

                {userData?.accessToken === "" ? (

                  <a href="/auth/login" className="text-reset d-block">
                    Sign In
                  </a>
                ) : (
                  <span className="nav-link px-0" onClick={() => LogoutUser()}>
                    Logout
                  </span>
                )}

                <hr />

                <div className="text-reset d-block mb-2" style={{ fontWeight: '600' }}>Shop By Categories</div>

                <div className="text-reset d-block mb-2 ml-2">
                  <svg onClick={handleMobMenu} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="25" height="25" strokeWidth={2.5} stroke="currentColor" className={"w-6 h-6 menu-arrow" + (subMenu ? " rotate-180" : "")}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                  <span onClick={() => history.push(`/category/cookware`)}>Cookware</span>
                  <div className={`${subMenu ? "d-block" : "d-none"}`}>
                    <div className="mobileAnchor">
                      <a href="/category/stainless-steel-series">Stainless Steel Series</a>
                    </div>
                    <div className="mobileAnchor">
                      <a href="/category/triply-series">Triply Series</a>
                    </div>
                    <div className="mobileAnchor">
                      <a href="/category/bronze-series">Bronze Series</a>
                    </div>
                    <div className="mobileAnchor">
                      <a href="/category/cast-iron-series">Cast Iron Series</a>
                    </div>
                  </div>
                </div>

                <div className="text-reset d-block mb-2 ml-2" onClick={() => history.push(`/category/tableware`)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="25" height="25" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6 menu-arrow">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                  <span>Tableware</span>
                </div>

                {/* <div className="text-reset d-block mb-2 ml-2" onClick={() => history.push(`/category/kitchen-tools`)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="25" height="25" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6 menu-arrow">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                  <span>Kitchen Tools</span>
                </div> */}

                <div className="text-reset d-block mb-2 ml-2" onClick={() => history.push(`/category/kitchen-mate`)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="25" height="25" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6 menu-arrow">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                  <span>Kitchen Mate</span>
                </div>
                <div className="text-reset d-block mb-2 ml-2" >
                <svg onClick={handleMobMenu2} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="25" height="25" strokeWidth={2.5} stroke="currentColor" className={"w-6 h-6 menu-arrow" + (subMenu2 ? " rotate-180" : "")}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                  <span onClick={() => history.push(`/category/kitchen-tools-accessories-and-spares`)}>Kitchen tools, Accessories and Spares</span>
                  <div className={`${subMenu2 ? "d-block" : "d-none"}`}>
                  <div className="mobileAnchor">
                    <a href="/category/kitchen-tools">Kitchen Tools</a>
                    </div>
                    <div className="mobileAnchor">
                    <a href="/category/accessories">Accessories</a>
                    </div>
                    <div className="mobileAnchor">
                    <a href="/category/spares">Spares</a>
                    </div>
                  </div>
                </div>


                <div className="text-reset d-block mb-2 mt-4" style={{ fontWeight: '600' }} onClick={() => history.push(`/category/allproducts`)}>
                  <span>All Products</span>
                </div>

                <a href="/static/about" style={{ fontWeight: '600' }} className="text-reset d-block mt-3">
                  About VB Dace
                </a>
                <a href="/contact-us" style={{ fontWeight: '600' }} className="text-reset d-block mt-0">
                  Contact Us
                </a>
                <a href="/our-experience-centers" style={{ fontWeight: '600' }} className="text-reset d-block mt-0">
                  Our Experience Centers
                </a>


              </div>


            </div>


          )
        }
      </div >
    </>
  );
}

// function mapStateToProps(state) {
//     return {
//         categories: state.categories
//     };
// }

// function mapDispatchToProps(dispatch) {
//     return {
//         actions: bindActionCreators(
//             ...productAction,
//             dispatch
//         ),
//     };
// }

export const TopNav = Nav;
// export default connect(mapStateToProps, mapDispatchToProps)(Nav);



